// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"25":"ui/main/css/main","27":"ui/main/css/category_listing","587":"ui/main/css/product","794":"ui/main/css/homepage","957":"ui/main/css/vendor_listing"}[chunkId] + ".css";
};